import React, { useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";

import "./App.css";
import Weather from "./Weather";
import Footer from "./Footer";
import Forecast from "./Forecast";

function App() {
  let [loading, setLoading] = useState(true);
  let [weather, setWeather] = useState({});
  let [city, setCity] = useState("London");

  function search() {
    const apiKey = "2718952144ed077c12e7c160fb6fc351";
    let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
    axios.get(apiUrl).then(handleResponse);
  }

  function handleSubmit(event) {
    event.preventDefault();
    search();
  }

  function handleInput(event) {
    setCity(event.target.value);
  }

  function handleResponse(response) {
    setWeather({
      temperature: response.data.main.temp,
      wind: response.data.wind.speed,
      humidity: response.data.main.humidity,
      description: response.data.weather[0].description,
      cityName: response.data.name,
      iconUrl: `https://openweathermap.org/img/wn/${response.data.weather[0].icon}@2x.png`,
      iconCode: response.data.weather[0].icon,
      dt: new Date(response.data.dt * 1000),
      latitute: response.data.coord.lat,
      longitute: response.data.coord.lon,
    });
    setLoading(false);
  }

  if (loading) {
    search();
    return <p>Loading...</p>;
  } else {
    return (
      <section className="weather-app mt-5 mb-5 p-5 rounded">
        <div className="form">
          <form id="search-form" onSubmit={handleSubmit}>
            <input
              type="search"
              placeholder="Enter a city..."
              required
              className="search-form"
              id="search-input"
              onChange={handleInput}
            />
            <input type="submit" value="Search" className="search-button" />
          </form>
        </div>
        <Weather data={weather} />
        <Forecast lon={weather.longitute} lat={weather.latitute} />
        <Footer />
      </section>
    );
  }
}

export default App;
